import * as tf from "@tensorflow/tfjs";
export function arrayToTensor(dataset) {
    return tf.tensor(dataset);
}
export function tensorToArray(tensor) {
    return tensor.arraySync();
}
export function logMemory() {
    console.log(tf.memory().numTensors);
}
